import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ValidRecord from '#models/valid_record'

@define
export default class ConsentForm extends ValidRecord {
    @(type(String).required.as) name: string
    @(type(PowerDate).required.as) date: Date
    @(type(null).required.as) signature: any
}
